import { FieldDefinition } from './edit-modal/types';
import './edit-modal/registerFields';

export const extractCardDataFromTemplate = (
  sourceCard: Record<string, unknown>,
  template: { fields: FieldDefinition[] }
): Record<string, unknown> => {
  const data: Record<string, unknown> = {};

  template.fields.forEach(field => {
    const rawValue = sourceCard?.[field.name];

    if (rawValue !== null && rawValue !== undefined) {
      if (Array.isArray(rawValue)) {
        data[field.name] = rawValue.filter(
          (item: { mediaUrl?: unknown; url?: unknown; id?: unknown }) =>
            item && (item.mediaUrl || item.url || item.id)
        );
      } else {
        data[field.name] = rawValue;
      }
    }
  });

  return data;
};
